import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

function Login() {
  const { t } = useApp();
  const [form, setForm] = useState({ email:"", password:"" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault(); setError(""); setBusy(true);
    try {
      const res = await axios.post("/api/login", form);
      localStorage.setItem("spar_token", res.data.token);
      localStorage.setItem("spar_user", JSON.stringify(res.data.artist));
      navigate("/artists");
    } catch(err) {
      setError(err.response?.data?.error || "Login failed.");
    } finally { setBusy(false); }
  };

  return (
    <section className="section container">
      <div className="auth-wrap">
        <div className="center" style={{ marginBottom:24 }}>
          <span className="eyebrow">{t("memberAccess")}</span>
          <h1 className="section-title">{t("welcomeBack")}</h1>
        </div>
        <form className="card-panel" onSubmit={onSubmit}>
          {error && <div className="alert alert-error">{error}</div>}
          <div className="field"><label>{t("email")}</label><input className="input" type="email" name="email" value={form.email} onChange={onChange} required autoComplete="email" /></div>
          <div className="field"><label>{t("password")}</label><input className="input" type="password" name="password" value={form.password} onChange={onChange} required autoComplete="current-password" /></div>
          <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={busy}>
            {busy ? t("signingIn") : t("signIn")}
          </button>
          <p className="hint center" style={{ marginTop:14 }}>{t("newHere")} <Link to="/register">{t("joinLink")}</Link></p>
          <p className="hint center" style={{ marginTop:6 }}><Link to="/forgot-password">{t("forgotPassword")}</Link></p>
        </form>
      </div>
    </section>
  );
}
export default Login;
